"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    sidebarHeaderRoot: {
      backgroundColor: '#33447c',
      color: '#FFFFFF'
    },
    sidebarHeaderIcon: {
      color: '#FFFFFF'
    },
    merchantLink: {
      color: '#029cef'
    },
    dotActive: {
      backgroundColor: '#029cef'
    }
  };
});
var _default = useStyles;
exports.default = _default;